'use client';

import ProductCardTitle from 'components/product-comparison-grid/product-comparison-card/product-card-title';
import { OrderItemPart } from 'services/cart';
import { useProductPriceData } from '../../app/[lang]/[esite]/(core)/(search-display)/hooks/useProductPriceData';
import { PAGE_SIZE } from 'app/[lang]/[esite]/(core)/category/[category]/constants';

// TODO: Optional props will be removed as soon as we pass down the remaining props in federated search
interface CardTitleWrapperProps {
  productName: string;
  productNumber: string;
  href: string;
  className?: string;
  isHeadlessPDPEnabled?: boolean;
  locationId?: string;
  orderItem?: OrderItemPart | { orderItemId: string };
  products: Product[];
  serialNumber?: string;
  index: number;
  ecommerceListNameAndId: string;
  cartId?: string;
  page: number;
  nerEquipmentModel?: string;
}

const CardTitleWrapper = (props: CardTitleWrapperProps) => {
  const {
    productNumber,
    index,
    products,
    serialNumber,
    ecommerceListNameAndId,
    page,
    nerEquipmentModel
  } = props;
  const indexPage = PAGE_SIZE * (page - 1);
  const productIndex = indexPage + index;
  const { productPriceData, fitmentCheck } = useProductPriceData({
    productNumber,
    index: productIndex + 1,
    products,
    serialNumber,
    ecommerceListNameAndId,
    nerEquipmentModel
  });

  return (
    <ProductCardTitle
      {...props}
      productPriceData={productPriceData}
      fitmentCheck={fitmentCheck}
    />
  );
};

export default CardTitleWrapper;
